<template>
  <div class="z2-message-action pointer d-flex align-items-center justify-content-around">
    <span
      v-if="message.isShowReplyIcon"
      class="font-13 text-grey600 ms-2 me-1 pe-1"
      style="border-right: thin solid #dcdfe9"
      @click="$emit('showRepliedMessage', message)">
      Trả lời
    </span>

    <CustomPopoverV2
      placement="top-start"
      width="160"
      trigger="hover"
      ref="customPopoverV2">
      <div
        style="margin: -12px"
        class="font-size-13 pointer"
        @click="$refs.customPopoverV2.showPopper = false">
        <div
          @click="$emit('showMessageSharePopup', message)"
          v-if="message.isShowMessageSharePopup"
          class="item-popover py-2 ps-2 d-flex align-items-center">
          <IconV2
            class="me-2"
            name="v2-share" />
          Chuyển tiếp
        </div>
        <div
          @click="$emit(isPinMsg ? 'unPinMessage' : 'pinMessage', isPinMsg ? isPinMsg : message)"
          v-if="message.isShowListIcon && message.isCanPin"
          class="item-popover py-2 ps-2 d-flex align-items-center">
          <IconV2
            class="me-2"
            name="v2-mark1" />
          {{ isPinMsg ? "Bỏ ghim" : "Ghim tin nhắn" }}
        </div>
        <div
          @click="copy"
          v-if="message.isShowListIcon && message.msgType === 'webchat'"
          class="item-popover py-2 ps-2 d-flex align-items-center">
          <IconV2
            class="me-2"
            name="v2-copy" />
          Copy tin nhắn
        </div>
        <div
          @click="$emit('downloadImage', message)"
          v-if="message.isShowListIcon && message.msgType === 'chat.photo'"
          class="item-popover py-2 ps-2 d-flex align-items-center">
          <IconV2
            class="me-2"
            name="v2-import" />
          Lưu ảnh về máy
        </div>
         <div
          @click="$emit('selectMultiMessages', message)"
          class="item-popover py-2 ps-2 d-flex align-items-center">
          <IconV2
            class="me-2"
            name="v2-grid" />
          Chọn nhiều tin nhắn
        </div>
        <div
          @click="$emit('undoMessage', message)"
          v-if="message.isShowUndoIcon && !message.checkUndoMessage && !message.checkDeleteMessage"
          v-bind:style="message.id.uidFrom !== '0' ? 'display:none' : ''"
          class="item-popover py-2 ps-2 d-flex align-items-center">
          <IconV2
            class="me-2"
            name="v2-reset" />
          Thu hồi
        </div>
        <div
          v-if="message.isShowDelete && !message.checkDeleteMessage"
          @click="$emit('deleteMessage', message)"
          class="item-popover py-2 ps-2 text-red500 d-flex align-items-center">
          <IconV2
            class="me-2"
            name="el-icon-delete"
            size="14px" />
          Xoá chỉ ở phía tôi
        </div>
      </div>

      <el-tooltip
        :disabled="true"
        slot="reference"
        effect="dark"
        content="Thêm"
        placement="bottom">
        <el-image
          v-if="message.isShowThreeDot"
          class="me-1"
          style="object-fit: contain; max-height: 16px; max-width: 20px;"
          src="/assets/images/three_dots.svg" />
      </el-tooltip>
    </CustomPopoverV2>
  </div>
</template>

<script>
import CustomPopoverV2 from "./common/popover/CustomPopoverV2";
// import { COMMON } from "../lib/Common";

export default {
  props: ["message", "isPinMsg"],
  components: {
    CustomPopoverV2,
  },
  methods: {
    copy() {
      this.$emit("copy", this.message);
    },
  },
};
</script>

<style>
</style>
